import { type AssistantMessageProps as Props, Markdown } from '@copilotkit/react-ui'
import { type DefaultProps } from '@egw/components'
import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { DotsLoader } from '../dots-loader/dots-loader'

interface AssistantMessagePageProps extends Props, DefaultProps {
  isLastMessage?: boolean
}

export const AssistantMessage: FC<AssistantMessagePageProps> = ({
  message,
  isLoading,
  className,
  testId,
  id,
  ariaLabel,
  isLastMessage,
}) => {
  const finalClasses = twMerge('', className)
  const subComponent = message?.generativeUI?.()

  return (
    <div
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      className={finalClasses}
    >
      {/* Always render generativeUI subComponent (e.g., charts) when it exists */}
      {subComponent ? <div className="my-2">{subComponent}</div> : null}

      {message || isLoading ? (
        <div className="flex items-start py-2x">
          <div className="px-4 rounded-xl pt-2x">
            {message ? <Markdown data-testid="chat-message-text" content={message.content || ''} /> : null}
            {isLoading ? <DotsLoader /> : null}
          </div>
        </div>
      ) : null}
    </div>
  )
}
